import { Component, OnInit } from "@angular/core";
import { MatDialog } from "@angular/material/dialog";
import { environment } from "src/environments/environment";

@Component({
  selector: "app-unauthorised",
  templateUrl: "./unauthorised.component.html",
  styleUrls: ["./unauthorised.component.scss"],
})
export class UnauthorisedComponent implements OnInit {
  constructor(    public dialog: MatDialog,
    ) {}
  url = environment.loginUrl;
  ngOnInit(): void {}
  openUnauthor()
  {
  //   const dialogRef = this.dialog.open(ApprovalPopupDialog, {
  //     data: {
  //       unauthor: true,
  //      },
  //   });
   }
}

